<div *ngIf="groupsList">
    <ng-container *ngIf="this.showInputGroup; then inputGroup; else selectGroup">
    </ng-container>

    <ng-template #inputGroup>
        <div class="input-box">
            <label name="selectList" for="selectList">{{'groups.create-new-group' | translate}}</label>
            <button class="input-box__select-group-button" (click)="toggleInput()">
                {{'common.select-from-list' | translate}}
            </button>
            <form [formGroup]="newGroupForm">
                <input nbInput
                       fullWidth
                       type="text"
                       id="groupName"
                       name="groupName"
                       formControlName="groupName"
                       required
                       placeholder="{{'common.type-name' | translate}}"
                       [fieldSize]="'large'"
                       [status]="hasError('groupName') ? 'danger':'primary'" />
                <app-control-messages [control]="getFormControl('groupName')"></app-control-messages>
            </form>
        </div>
    </ng-template>

    <ng-template #selectGroup>
        <div class="input-box">
            <label name="selectList" for="selectList">{{'device.edit.select-device-group' | translate}}</label>
            <button class="input-box__new-group-button" (click)="toggleInput()">
                {{'groups.new' | translate}}
            </button>
            <nb-select [(selected)]="selectedGroup" 
                       placeholder="{{'common.unassigned' | translate}}" 
                       fullWidth='true' 
                       size="large" 
                       status="primary"
                       [disabled]="groupsList.length < 1">
                <nb-option *ngFor="let group of groupsList; trackBy: trackByFn" [value]="group.id">{{group.name}}</nb-option>
            </nb-select>
        </div>
    </ng-template>
</div>